module.exports = __webpack_public_path__ + "img/profile.3.457f457.svg";